import {
  ADD_EMTITHAL_MASTER_TASK,
  EDIT_EMTITHAL_MASTER_TASK,
  GET_EMTITHAL_MASTER_TASKS,
  GET_MAIN_TASK_LIST,
} from '../../../modules/constants';

export function getEmtithalMasterTasks(value) {
  return {
    type: GET_EMTITHAL_MASTER_TASKS,
    payload: value,
  };
}

export function getMainTaskList(value) {
  return {
    type: GET_MAIN_TASK_LIST,
    payload: value,
  };
}

export function addEmtithalMasterTask(payload) {
  return {
    type: ADD_EMTITHAL_MASTER_TASK,
    payload: { ...payload },
  };
}

export function editEmtithalMasterTask(value) {
  return {
    type: EDIT_EMTITHAL_MASTER_TASK,
    payload: value,
  };
}
